<template>
  <el-dialog title="选择导入内容" width="27%" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="weui-flex whd-tcenter mt-20 mb-40">
      <div class="weui-flex__item">
        <img src="/static/img/document.png" width="48" style="margin: 30px auto 15px" />
        <el-upload
          class="upload-demo"
          :data="uploadFiledata"
          :action="uploadFileUrl"
          :on-success="handleFileSuccess"
          :on-error="handleError"
          :before-upload="beforeUploadFile"
          :show-file-list="false"
          :disabled="defaultlimit===0?true:false"
          >
          <el-button size="small" type="primary" @click="onClickBtn">导入文件</el-button>
          <div slot="tip" class="el-upload__tip">仅支持PPT、PDF</div>
        </el-upload>
      </div>
      <div class="weui-flex__item">
        <img src="/static/img/image.png" width="48" style="margin: 30px auto 15px" />
        <el-upload ref="uploadImg"
          class="upload-demo"
          :data="uploaddata"
          :action="uploadImgsUrl"
          :on-success="handleImgsSuccess"
          :on-error="handleError"
          :on-exceed="handleExceed"
          :before-upload="beforeUploadImgs"
          :show-file-list="false"
          :disabled="defaultlimit===0?true:false"
          multiple
          :limit="defaultlimit"
          >
          <el-button size="small" type="primary" @click="onClickBtn">批量导入图片</el-button>
          <div slot="tip" class="el-upload__tip">每张图片不超过10M<br/>建议每张图片尺寸保持一致</div>
        </el-upload>   
      </div>
    </div>
  </el-dialog>
</template>

<script>
import api from "@/api.js";
export default {
  name: "addPageDialog",
  props: ["visible", "limit", "id", "len"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    },
    limit(val, oldVal) {
      this.defaultlimit = val;
      this.uploadFiledata.page_num = val;
    }
  },
  data() {
    return {
      dialogVisible: false,
      uploadImgsUrl: api.uploadTokenImg,
      uploadFileUrl: api.brochure_file,
      uploaddata: {token: sessionStorage.getItem("token")},
      uploadFiledata: {token: sessionStorage.getItem("token"), sign: "123"},
      defaultlimit: 1,
      attachmentList: [],
      currLength: 0
    }
  },
  mounted() {
    this.defaultlimit = this.limit;
    this.uploadFiledata.page_num = this.limit;  
  },
  methods: {
    onClickBtn() {
      if (this.defaultlimit === 0) {
        this.$message.warning("图片已达到最大限制");
        return false;
      } else {
        this.$message.warning({
          message: "请注意：导入的页数、图片过多会导致加载速度变慢！", 
          duration: 5000
        });
      }
    },
    // 导入之前
    beforeUploadFile(file) {
      this.attachmentList = [];
      this.dialogVisible = false;
      const isFile = file.type === "application/vnd.ms-powerpoint" || file.type === "application/pdf" || file.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation";
      let status = true;
      if (!isFile) {
        this.$message.error("上传文件只能是 PPT或者PDF 格式!");
        status = false;
        return false;
      }  
      if(status){
        this.loadingStatus = this.$loading({
          lock: true,
          text: '文件转换中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass: 'fontColor'
        });
      }    
    },
    beforeUploadImgs(file) {
      this.attachmentList = [];
      this.dialogVisible = false;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 10;
      let status = true;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或者PNG 格式!");
        status = false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
        status = false;
      }
      if(status){
        this.loadingStatus = this.$loading({
          lock: true,
          text: "图片导入中",
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass: 'fontColor'
        });
      }

      return isJPG && isLt2M;
    },
    // 导入文件
    handleFileSuccess(res, file) {
      if (res.code === 1) {
        this.loadingStatus.close();
        this.$message.warning(res.msg);
      } else {
        for (let i = 0; i < res.file.length; i++) {
          let obj = {
            jump_type: 0,
            item_id: "",
            item_name: "",
            item_price: "",
            item_img: "",
            page_name: "页面" + (this.len + i + 1),
            page_img: res.file[i].img_url,
            button_text: ""
          }
          if (this.id) {
            obj.page_id = 0;
          }     
          this.attachmentList.push(obj);
        }
        this.loadingStatus.close();
        this.$emit("uploadsucess", this.attachmentList);        
      }
    },
    // 上传成功
    handleImgsSuccess(res, file, fileList) {
      this.currLength = this.currLength + 1
      if (res.code === 0) {
        let obj = {
          jump_type: 0,
          item_id: "",
          item_name: "",
          item_price: "",
          item_img: "",
          page_name: "页面" + (this.len + 1),
          page_img: res.path,
          button_text: ""
        }
        if (this.id) {
          obj.page_id = 0;
        }       
        this.$emit("uploadsucess", obj);
        if (this.currLength == fileList.length) {
          this.loadingStatus.close();
          this.$refs.uploadImg.clearFiles();
          this.currLength = 0;
        }    
      } else {
        this.$message({
          type: "error",
          message: `第${this.currLength}张${res.msg}` 
        });  
        if (this.currLength == fileList.length) {
          this.loadingStatus.close();
          this.$refs.uploadImg.clearFiles();
          this.currLength = 0;
        } 
      }   
    },
    handleError(err, file) {
      this.$message({
          type: "error",
          message: "上传失败"
      });
      return false;
    },
    handleExceed(files, fileList) {
      if (files.length > this.defaultlimit) {
        this.$message.warning(`最多只能选择${this.defaultlimit}张图片，总共选择了${files.length}张`);
      } 
    }
  }
}
</script>

<style type="text/css" scoped>
.filebox{position: relative; display: inline-block; overflow: hidden;}
.filebox-input{position: absolute; top: 0; left: 0; width: 100%; height: 100%; opacity: 0; cursor: pointer;}
</style>